import * as angular from "angular";
import {IController} from "angular";
import {ImportEntitiesService} from "../../services/import-entities.service";
import {BatchRequestsService} from "../../../batch/services/batch-requests.service";
import {ImportFieldType} from "../../types/import-field-type.enum";
import * as _ from "lodash";
import {SplitService} from "../../services/split-service.service";

export class ImportFieldTypeInputComponent implements IController {
  fieldType: string;
  value: any;
  rowIndex: number;
  onChangeValue: Function;

  public importFieldType: typeof ImportFieldType = ImportFieldType;
  public packagesOptionTypes: any;
  public dateTimestamp: number;

  constructor(private splitService: SplitService) {
  }

  $onInit() {
    const sitePackageItems = this.splitService.getSitePackageItems();
    this.packagesOptionTypes = _.map(sitePackageItems, (s: any) => {
      return s.id;
    })
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (!!this.fieldType && !!this.value && this.importFieldType[this.fieldType] === 'date') {
      this.dateTimestamp = new Date(this.value).getTime();
    }
  }


  onDateValueChange(timestamp: number) {
    const date = new Date(timestamp);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // months are 0-indexed
    const dd = String(date.getDate()).padStart(2, '0');

    const formattedDate = `${yyyy}-${mm}-${dd}`;

    this.onChangeValue({value: formattedDate});
  }


}

angular
  .module('bringoz.admin.commons')
  .component('importFieldTypeInput', {
    bindings: {
      value: '<',
      fieldType: '<',
      rowIndex: '<',
      onChangeValue: '&'
    },
    templateUrl: 'app/modules/commons/components/import-field-type-input/import-field-type-input.html',
    controller: ImportFieldTypeInputComponent
  });
